// VAULTS
export const API_VAULTS = '/vaults';

export const API_VAULTS_PUBLISHED = `${API_VAULTS}/published`;

export const API_VAULTS_SAVED = `${API_VAULTS}/saved`;

export const API_VAULTS_BY_CREATOR = `${API_VAULTS}/by-creator`;

export const API_VAULT_UPDATE_DATA = `${API_VAULTS}/update-data`;

export const API_VAULTS_UPDATE = `${API_VAULTS}/update-data/batch`;

export const API_VAULTS_ARCHIVE = `${API_VAULTS}/archive`;

export const API_VAULTS_DELETE = `${API_VAULTS}/soft-delete`;

export const API_VAULTS_UNARCHIVE = `${API_VAULTS}/unarchive`;

export const API_VAULTS_SAVE = `${API_VAULTS}/save`;

export const API_VAULTS_UNSAVE = `${API_VAULTS}/unsave`;

export const API_VAULTS_CONFIG_LM = `${API_VAULTS}/config-lm`;

export const API_VAULTS_UPDATE_FARMS = `${API_VAULTS}/update-farms`;

export const API_VAULTS_ESTIMATE_APY = `${API_VAULTS}/estimate-apy`;

export const API_VAULTS_MIGRATION = `${API_VAULTS}/migration`;

export const API_SIMILAR_VAULTS = `${API_VAULTS}/similar-by-farms`;

export const API_VAULTS_AUTOHARVEST_STATUS = `${API_VAULTS}/autoharvest-status`;

export const API_VAULTS_CLAIMABLE = `${API_VAULTS}/claimable`;

export const API_VAULTS_CREATE = `${API_VAULTS}/create`;

export const API_VAULTS_UPDATE_INFO = `${API_VAULTS}/info`;

export const API_VAULTS_ACTION_HISTORY = `${API_VAULTS}/action-history`;

// vault-factory
export const API_VAULT_FACTORIES = '/vault-factories';

// tokens
export const API_TOKENS = '/tokens';
export const API_DEF_FI_STATS = `${API_TOKENS}/dexfi`;

// components
export const API_COMMON_TAGS_BADGES = '/common/tags-badges';

export const API_COMMON_STATS = '/common/stats';

export const API_COMMON_PERSONAL_KPI = '/common/personal-kpi';

// farms
export const API_FARMS_LIST = '/farms';

export const API_DEX_FACTORIES = '/farms/dex-factories';

export const API_FARMS_POOL_V3_LIQUIDITY_CHART = '/pool-v3-liquidity/chart';

// statistics

export const API_STATISTICS = '/statistics';

export const API_STATISTICS_INVEST_SNAPSHOTS = `${API_STATISTICS}/invest/chart`;

export const API_STATISTICS_REINVEST_SNAPSHOTS = `${API_STATISTICS}/reinvest/chart`;

export const API_STATISTICS_VAULT_ACCOUNT = `${API_STATISTICS}/vault-account`;

export const API_STATISTICS_VAULT_FARM_V3_RANGE_CHART = `${API_STATISTICS}/vault-farm-v3-range/chart`;

export const API_STATISTICS_APY_PRICE_CHART = `${API_STATISTICS}/apy-price/chart`;

export const API_STATISTICS_WEEKLY_REVENUE = `${API_STATISTICS}/weekly-revenue`;
